module.exports = __webpack_public_path__ + "img/SuperRich_EGM.d267fa4b.png";